module.exports = __webpack_public_path__ + "static/media/visit_3.e5ff73ce.jpg";